import { useCallback, useState } from "react";
/**
 * 모바일 필터 시트 및 카테고리 드로어 UI 상태를 관리하는 훅
 */ export const useMobileUI = ()=>{
    const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
    const [mobileFilterExpandedKey, setMobileFilterExpandedKey] = useState();
    const [isMobileCategoryDrawerOpen, setIsMobileCategoryDrawerOpen] = useState(false);
    const openMobileFilter = useCallback((filterKey)=>{
        setMobileFilterExpandedKey(filterKey);
        setIsMobileFilterOpen(true);
    }, []);
    const closeMobileFilter = useCallback(()=>setIsMobileFilterOpen(false), []);
    const openMobileCategoryDrawer = useCallback(()=>setIsMobileCategoryDrawerOpen(true), []);
    const closeMobileCategoryDrawer = useCallback(()=>setIsMobileCategoryDrawerOpen(false), []);
    return {
        isMobileFilterOpen,
        mobileFilterExpandedKey,
        isMobileCategoryDrawerOpen,
        openMobileFilter,
        closeMobileFilter,
        openMobileCategoryDrawer,
        closeMobileCategoryDrawer
    };
};
